import {
  FILE_UPLOAD_DISALLOWED_FILE_EXTENSIONS,
  FILE_UPLOAD_SIZE_LIMIT_MB
} from "@/constants/fileUpload";

export function convertFileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export async function convertFileToBase64(file) {
  const dataUrl = await convertFileToDataUrl(file);
  return dataUrl.split(",")[1];
}

export function validateFileAttachment(file) {
  if (!file) return;

  // validate file size
  const limitInBytes = FILE_UPLOAD_SIZE_LIMIT_MB * 1000000;
  if (file.size > limitInBytes) {
    return `${FILE_UPLOAD_SIZE_LIMIT_MB}MB file limit exceeded.`;
  }

  // validate file extension
  const fileExtension = file.name?.includes(".")
    ? `.${file.name.split(".").slice(-1)[0]}`
    : null;
  if (FILE_UPLOAD_DISALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
    return `${fileExtension} files are not allowed`;
  }
}
